import httpService from './httpService';
import {
    GetCorporationsResponse,
    CorporateLoginRequest,
    CorporateLoginResponse,
    CustomAxiosRequestConfig,
    APIResponse,
    CorporationDetailResponse,
} from '../types';

export async function getCorporationsAPI(): Promise<GetCorporationsResponse> {
    const response = await httpService.get('/corporate', {
        tokenType: 'login_token',
    } as CustomAxiosRequestConfig);
    return response.data;
}

export function corporateLoginAPI(request: CorporateLoginRequest): APIResponse<CorporateLoginResponse> {
    return httpService.post('/corporate/login', request, {
        tokenType: 'login_token',
    } as CustomAxiosRequestConfig);
}

export function fetchCorporationDetailAPI(cid: number): APIResponse<CorporationDetailResponse> {
    return httpService.get(`/corporate/${cid}`, {
        tokenType: 'login_token',
    } as CustomAxiosRequestConfig);
}
